// src/pages/Home.js
import React, {useEffect, useRef, useState} from 'react';
import WOW from 'wow.js';
import arrowIcon from '../assets/img/icon_arrow.svg';
import {
    AgendaGroup,
    ErrorAlert,
    Footer,
    Header,
    Loading,
    PartnerLogos,
    Popup,
    SpeakerSlider,
    TabGroup
} from "../components";
import useScrollEffects from '../hooks/useScrollEffects';
import {useDateActivityBanner, useDateActivityInfo} from "../hooks/useDateActivityInfo";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import {useDateSpecialReport} from "../hooks/useDateSpecialReport";
import {useDateAgenda} from "../hooks/useDateAgenda";

const Home = () => {
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);

    const {data: bannerData, isLoading: isBannerLoading, isError: isBannerError} = useDateActivityBanner(0, 1);
    const {
        data: activityInfoData,
        isLoading: isActivityInfoLoading,
        isError: isActivityInfoError
    } = useDateActivityInfo();
    const {
        data: specialReportData,
        isLoading: isSpecialReportLoading,
        isError: isSpecialReportError
    } = useDateSpecialReport();
    const {data: agendaData, isLoading: isAgendaLoading, isError: isAgendaError} = useDateAgenda();

    const mainRef = useRef(null);
    const footerRef = useRef(null);

    // 使用自定義的 useScrollEffects
    const {mainBnEffect, footEffect} = useScrollEffects(mainRef, footerRef);

    useEffect(() => {
        // 初始化 WOW 動畫
        new WOW().init();
    }, []);

    return (
        <div>
            {/* Header 區塊 */}
            <Header data={activityInfoData}/>

            {/* 主要內容 */}
            <main ref={mainRef}>

                {isBannerLoading && <Loading/>}
                {isBannerError && <ErrorAlert/>}
                {!isBannerLoading && bannerData.content.map((banner, index) => (
                    <section
                        key={index}
                        className={`areaMainBN wow fadeIn ${mainBnEffect ? 'mainBnEffect' : ''}`}
                        data-wow-offset="1"
                        data-wow-duration="1s">
                        <div className="wrap">
                            <img src={banner.imgUrl} alt="Top Banner"/>
                        </div>
                    </section>
                ))}

                <section className="areaAbout wow fadeIn" data-wow-offset="1" data-wow-duration="1s" id="topic_about">
                    <div className="wrap">
                        <div className="aboutInfo">
                            {isActivityInfoLoading && <Loading/>}
                            {isActivityInfoError && <ErrorAlert/>}
                            {!isActivityInfoLoading && activityInfoData ? (
                                <TabGroup data={activityInfoData}/>
                            ) : ''}
                            <div className="textSide">
                                <article>
                                    {activityInfoData?.content ? (<div dangerouslySetInnerHTML={{
                                        __html: parse(DOMPurify.sanitize(activityInfoData.content, {
                                            FORBID_ATTR: ['style'],
                                            ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'li', 'ol', 'a', 'img'],
                                            ALLOWED_ATTR: ['href', 'alt', 'src', 'title', 'width', 'height'],
                                        }))
                                    }}/>) : ''}
                                </article>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="areaSpeaker wow fadeIn" data-wow-offset="1" data-wow-duration="1s"
                         data-wow-delay="0.3s" id="topic_speaker">
                    <div className="wrap">
                        <h2>講師陣容</h2>
                        <SpeakerSlider onOpenPopup={(data) => {
                            setPopupOpen(true);
                            setPopupData(data);
                        }}/>
                    </div>
                </section>

                <section className="areaAganda wow fadeIn" data-wow-offset="1" data-wow-duration="1s"
                         data-wow-delay="0.3s" id="topic_aganda">
                    <div className="bg_top">
                        <div className="bg_bt">
                            <div className="wrap">
                                <h2>精彩議程</h2>
                                <small>The Organizer reserves the right to modify the program</small>
                                <AgendaGroup data={agendaData} isLoading={isAgendaLoading} isError={isAgendaError}/>
                            </div>
                        </div>
                    </div>
                </section>

                <section
                    className={`areaReport wow fadeIn ${footEffect ? 'footEffect' : ''}`}
                    data-wow-offset="1"
                    data-wow-duration="1s"
                    data-wow-delay="0.3s"
                    id="topic_report"
                >
                    <div className="wrap">
                        <h2>專題報導</h2>
                        <ul className="reportList">
                            {isSpecialReportLoading && <Loading/>}
                            {isSpecialReportError && <ErrorAlert/>}
                            {!isSpecialReportLoading && specialReportData.content.map((specialReport, index) => (
                                <li key={index}>
                                    <figure className="card card_vv">
                                        <a href={specialReport.link}
                                           target="_blank" rel="noreferrer">
                                            <div className="card_img">
                                                <img src={specialReport.photoImageIdUrl} alt="報導圖片"/>
                                            </div>
                                            <div className="card-body">
                                                <h5 className="card-title">{specialReport.title}</h5>
                                                <p className="card-text">
                                                    {specialReport.summary}
                                                </p>
                                                <b className="more">
                                                    Read More <img src={arrowIcon} alt="More"/>
                                                </b>
                                            </div>
                                        </a>
                                    </figure>
                                </li>
                            ))}
                            {/* 其他報導項目依需求新增 */}
                        </ul>
                    </div>
                </section>

                <section className="areaPartner wow fadeIn" data-wow-offset="1" data-wow-duration="1s"
                         data-wow-delay="0.3s">
                    <PartnerLogos/>
                </section>
            </main>

            {/* Popup 區塊 */}
            <Popup open={popupOpen} onClose={() => setPopupOpen(false)} data={popupData}/>

            {/* Footer 區塊 */}
            <Footer ref={footerRef} data={activityInfoData}/>
        </div>
    );
};

export default Home;
